Vendd.Scripts.load(function () {

    var $form = $('.x-registration-b2b-form'), $submitButton, form, formData;

    if ($form.length < 1)
        return;

    $submitButton = $('.js-submit-button', $form);

    form = $form.get(0);

    importEmailForRegistration();

    formData = {
        companyName: "",
        occupation: "",
        taxAgency: $('select[name="taxAgency"]').val() || "",
        taxIdentifier: "",
        officerName: "",
        vatstatus: 0,
        email: $('input[name="email"]').val().trim() || "",
        emailConfirmation: "",
        username: "",

        town: "",
        address: "",
        number: "",
        postalCode: "",
        phone: "",
        password: "",
        passwordConfirmation: "",

        storesNumber: "",
        phoneTwo: "",
        mobile: "",
        socialSecurityNumber: "",
        fax: "",
        siteUrl: "",
        message: "",

        newsletter: false,
        reCaptchaCode: "",
        redirectUrl: $form.data('redirect') || "",
        acceptTerms: false,

        store: "",
        CompanyCategory: "",
        OpeningHours: "",
        area: $('select[name="area"]').val() || "",
        prefecture: "",
        ReceiveEinvoice: null,
        officerLastName: "",
        officerPosition: "",

        countryCode: $('select[name="countryCode"]').val() || LhApp.Context.Country,

        registrationSetData: registrationSetData || null
    };

    var useEmailAsLoginName = $form.data('useemailasloginname').toString().toLowerCase() === 'true';
    var areaAutoCompleteEnabled = $form.data('areaautocomplete').toString().toLowerCase() === 'true';
    var invoiceAutoComplete = $form.data('invoiceautocomplete').toString().toLowerCase() === 'true';

    var areaLabel = $form.data('arealabel');
    var areas = [];
    var cyprusAreasEnabled = venddProjectConfigs.Registration.CyprusAreasAutoCompletedEnabled;

    var registrationSetData = [];

    // reCAPTCHA
    var captchaWidgetId;
    var captchaId = "registrationCaptcha";
    var $captchaElement = $form.find("#" + captchaId);
    var $captchaContainer = $form.find('.recaptcha-container');
    var captchaEnabled = $captchaElement.length > 0 ? true : false;

    form.initRecaptcha = function () {

        if (!captchaEnabled)
            return;

        var sitekey = $captchaElement.data("sitekey");
        if (sitekey) {
            captchaEnabled = true;
            captchaWidgetId = grecaptcha.render(captchaId, {
                'sitekey': sitekey,
                'callback': form.recaptchaCallback
            });
        }
    };

    form.validateRecaptcha = function () {
        if (!captchaEnabled)
            return true;

        formData.reCaptchaCode = $captchaElement.find('.g-recaptcha-response').val();

        var res = false;

        if (formData.reCaptchaCode) {
            $captchaContainer.find('.recaptcha-required').removeClass('error');
            res = true;
        }
        else {
            $captchaContainer.find('.recaptcha-required').addClass('error');
        }

        return res;
    };

    form.resetRecaptcha = function () {
        // Website must only verify the user's reCAPTCHA response token (g-recaptcha-response) once.
        // If a verify attempt has been made with a particular token, it cannot be used again.
        // Call grecaptcha.reset() to ask the end user to verify with reCAPTCHA again.
        if (captchaEnabled)
            grecaptcha.reset(captchaWidgetId);
    };

    form.removeRecaptcha = function () {
        $captchaElement.remove();
    };

    form.recaptchaCallback = function () {
        form.validateRecaptcha();
    };

    form.getAreasForPostCode = function (envelope) {

        areas = envelope ? envelope.message.data : [];

        var html = Vendd.Handlebars.parse("registrationB2BArea_A", areas);
        $('.form-row.area .js-area-wrapper').html(html);

        //add new validation for area select
        var valOptArea = { area: { required: 'area-required' } };
        rf.removeField("area");
        rf.addField(valOptArea);

        if (areas.length < 1) {
            $('.form-row.area').removeClass('select');
            $('.form-row.area label').empty().append(areaLabel);

        } else {
            $('.form-row.area').addClass('select');

            //submit value in formData
            if (areas.length === 1) {
                formData.area = areas[0].Name;
                rf.validate("area");
            }

            //if City exists, submit the value in formData
            if (areas.length > 0 && areas[0].City.length > 0) {
                $('input[name = "town"]:text').val(areas[0].City);
                formData.town = areas[0].City;
            }
        }

        //validate postal code
        if (formData.countryCode === "GR")
            valOpts.postalCode.isGreekPostalCode.config.areas = areas;

        if (formData.countryCode === "CY")
            valOpts.postalCode.isCypriotPostalCode.config.areas = areas;
    };

    form.updatePostalCode = function (countryCode) {

        //delete validations related to country
        delete valOpts.postalCode.isGreekPostalCode;
        delete valOpts.postalCode.isCypriotPostalCode;

        //add validation
        if (countryCode === "GR")
            _.extend(valOpts.postalCode, { isGreekPostalCode: { validator: 'postalCode-invalid', config: { areas: areas } } });

        if (countryCode === "CY")
            _.extend(valOpts.postalCode, { isCypriotPostalCode: { validator: 'postalCode-invalid', config: { areas: areas } } });

        //update validation field
        var valOptPostalCode = { postalCode: valOpts.postalCode };
        rf.removeField("postalCode");
        rf.addField(valOptPostalCode);

    };

    form.setRegistrationData = function () {

        var $sets = $('.js-registration-set', $form);

        if ($sets.length < 1) return;

        //init array
        registrationSetData = [];

        $.each($sets, function (e, set) {
            var $set = $(set);

            var setData = {
                Name: $set.data('set-name'),
                Id: $set.data('set-id'),
                Values: []
            }

            $.each($('input[type="checkbox"]', $set), function (e, input) {
                if ($(input).is(':checked')) {
                    var setValues = {
                        Id: $(input).data('id'),
                        Name: $(input).data('name')
                    }

                    setData.Values.push(setValues);
                }
            });

            if (setData.Values.length > 0)
                registrationSetData.push(setData);
        });

        if (registrationSetData.length > 0)
            formData.registrationSetData = registrationSetData;
    };

    form.loading = function (loading) {
        if (loading) {
            $form.addClass('x-loading');
        } else {
            $form.removeClass('x-loading');
        }
    };

    form.onSuccess = function (envelope) {
        form.loading(false);

        var response = envelope.message.data;

        if (response.success && response.code === "Registration_OperationSuccesful") {
            //insert consents after registration success
            if (LhApp.Context.IsConsentsEnabled) {
                form.checkConsents();
            }

            $('.js-error', $form).hide();
            $('.js-exists', $form).hide();
            $('.js-content', $form).hide();

            form.removeRecaptcha();

            $('.js-success', $form).show();
            $('html,body').animate({ scrollTop: 0 }, 300);

            /* Track User Registration */
            if (typeof fbPixelTracker !== 'undefined' && typeof fbPixelCanTrack !== 'undefined') {
                if (fbPixelTracker && fbPixelTracker.Properties.FacebookPixelId && fbPixelCanTrack) {
                    fbq('track', 'CompleteRegistration');
                }
            }
            /* END Track User Registration */

        } else {

            if (response.code === 'Registration_EmailExists') {
                $('.js-error', $form).hide();
                $('.js-exists', $form).show();
                $('html,body').animate({ scrollTop: $('.js-exists', $form).offset().top - 100 }, 300);
            } else {
                $('.js-exists', $form).hide();
                $('.js-error', $form).show();
                $('html,body').animate({ scrollTop: $('.js-error', $form).offset().top - 100 }, 300);
            }

            form.resetRecaptcha();
        }

        $('input[name="password"]', $form).val("");
        $('input[name="passwordConfirmation"]', $form).val("");
        form.updatePasswordBar($('input[name="password"]', $form));
    };

    form.onFailure = function (envelope) {
        form.hideLoader();

        var response = envelope.message.data;
        if (response === 'Registration_EmailExists') {
            $('.js-error', $form).hide();
            $('.js-exists', $form).show();
            $('html,body').animate({ scrollTop: $('.js-exists', $form).offset().top - 100 }, 300);
        } else {
            $('.js-exists', $form).hide();
            $('.js-error', $form).show();
            $('html,body').animate({ scrollTop: $('.js-error', $form).offset().top - 100 }, 300);
        }

        $('input[name="password"]', $form).val("");
        $('input[name="passwordConfirmation"]', $form).val("");
        form.updatePasswordBar($('input[name="password"]', $form));
    };

    form.submit = function () {
        form.loading(true);

        formData.vatstatus = $('select[name="vatstatus"]').val();
        formData.newsletter = $('#chkNewsletter').prop("checked");

        var einvoiceVal = $("input:radio[name='einvoice']:checked").val();

        if (einvoiceVal === "true") {
            formData.ReceiveEinvoice = true;
        } else if (einvoiceVal === "false") {
            formData.ReceiveEinvoice = false;
        } else {
            formData.ReceiveEinvoice = null;
        }

        form.setRegistrationData();

        Vendd.MessageBus.publishAsync(form, new Vendd.User.Messages.B2BRegister(
            formData.companyName,
            formData.occupation,
            formData.taxAgency,
            formData.taxIdentifier,
            formData.officerName,
            formData.vatstatus,
            formData.email,
            formData.emailConfirmation,
            formData.username,
            formData.town,
            formData.address,
            formData.number,
            formData.postalCode,
            formData.phone,
            formData.password,
            formData.passwordConfirmation,
            formData.storesNumber,
            formData.phoneTwo,
            formData.mobile,
            formData.socialSecurityNumber,
            formData.fax,
            formData.siteUrl,
            formData.store,
            formData.CompanyCategory,
            formData.OpeningHours,
            formData.area,
            formData.prefecture,
            formData.officerLastName,
            formData.officerPosition,
            formData.message,
            formData.newsletter,
            formData.ReceiveEinvoice,
            formData.reCaptchaCode,
            formData.redirectUrl,
            formData.countryCode,
            formData.registrationSetData));
    };

    form.reset = function () {
        $('.js-error', $form).hide();
        $('.js-exists', $form).hide();
        $('.js-success', $form).hide();
        $('.js-content', $form).show();

        $('input[name="companyName"]', $form).val("");
        $('input[name="occupation"]', $form).val("");
        $('input[name="taxAgency"]', $form).val("");
        $('input[name="taxIdentifier"]', $form).val("");
        $('input[name="officerName"]', $form).val("");
        $('input[name="vatstatus"]', $form).val("");
        $('input[name="email"]', $form).val("");
        $('input[name="emailConfirmation"]', $form).val("");
        $('input[name="username"]', $form).val("");
        $('input[name="town"]', $form).val("");
        $('input[name="address"]', $form).val("");
        $('input[name="number"]', $form).val("");
        $('input[name="postalCode"]', $form).val("");

        $('input[name="phone"]', $form).val("");
        $('input[name="password"]', $form).val("");
        $('input[name="passwordConfirmation"]', $form).val("");
        $('select[name="storesNumber"]', $form).val("");
        $('input[name="phoneTwo"]', $form).val("");
        $('input[name="mobile"]', $form).val("");
        $('input[name="socialSecurityNumber"]', $form).val("");

        $('input[name="fax"]', $form).val("");
        $('input[name="siteUrl"]', $form).val("");
        $('input[name="message"]', $form).val("");
        $('input[name="store"]', $form).val("");
        $('input[name="CompanyCategory"]', $form).val("");
        $('input[name="OpeningHours"]', $form).val("");
        $('input[name="area"]', $form).val("");
        $('select[name="area"]', $form).val("");
        $('input[name="prefecture"]', $form).val("");

        $('input[name="officerLastName"]', $form).val("");
        $('input[name="officerPosition"]', $form).val("");

        rf.reset();
    };

    form.resetAddressFields = function () {

        $('input[name="address"]', $form).val("");
        $('input[name="number"]', $form).val("");
        $('input[name="postalCode"]', $form).val("");
        $('input[name="town"]', $form).val("");
        $('input[name="area"]', $form).val("");
        $('select[name="area"]', $form).val("");
        $('input[name="prefecture"]', $form).val("");

        form.getAreasForPostCode();

    };

    form.updatePasswordBar = function (field) {
        var value = field.val();
        var score = Vendd.Helpers.textStrength(value);

        var $passwordStrength = $('#chkPassLabel, #chkPassText');

        $passwordStrength.removeClass(function (i, css) {
            return (css.match(/(^|\s)level\S+/g) || []).join(' ');
        }).addClass('level' + score); 
    };

    $.fn.validationEngine.validations.passwordStrength = Vendd.Validations.passwordStrength;

    //init validation options
    var valOpts = {};

    //add required validations
    $.each($('input[data-required], textarea[data-required], select[data-required]', $form), function (e, el) {
        var inputName = $(el).attr('name');
        valOpts[inputName] = { required: inputName + '-required' };
    });

    //add consent validations
    $.each($('.consent.checkbox[data-required]', $form), function (e, el) {
        var consentType = $('input', el).attr('name');
        valOpts[consentType] = { checkboxRequired: consentType + '-required' };
    });

    //add AFM validation only if config parameter is true
    if (venddProjectConfigs.TaxIdentifierValidationEnabled && $('input[name="taxIdentifier"]', $form).length > 0) {
        valOpts.taxIdentifier = valOpts.taxIdentifier || {};
        _.extend(valOpts.taxIdentifier, { isGreekTaxIdentifier: 'taxIdentifier-invalid' });
    }

    //add email validation
    if ($('input[name="email"]', $form).length > 0) {
        valOpts.email = valOpts.email || {};
        _.extend(valOpts.email, { isEmail: 'email-invalid' });
    }

    //add email confirmation validation
    if ($('input[name="emailConfirmation"]', $form).length > 0) {
        valOpts.emailConfirmation = valOpts.emailConfirmation || {};
        _.extend(valOpts.emailConfirmation, { isEmail: 'emailConfirmation-invalid', match: { validator: 'emailConfirmation-match', matchField: 'email' } });
    }

    //add phone validation
    if ($('input[name="phone"]', $form).length > 0) {
        valOpts.phone = valOpts.phone || {};
        if (venddProjectConfigs.phoneLocalizationEnabled) {
            _.extend(valOpts.phone, { isValidPhoneLocalized: { validator: 'phone-invalid', config: { type: 'phone' } } });
        } else {
            if (venddProjectConfigs.Registration.GreekPhoneValidation) {
                _.extend(valOpts.phone, { isGreekPhone: 'phone-invalid' });
            } else {
                _.extend(valOpts.phone, { isPhoneNumber: 'phone-invalid' });
            }
        }
    }

    //add mobile validation
    if ($('input[name="mobile"]', $form).length > 0) {
        valOpts.mobile = valOpts.mobile || {};
        if (venddProjectConfigs.phoneLocalizationEnabled) {
            _.extend(valOpts.mobile, { isValidPhoneLocalized: { validator: 'mobile-invalid', config: { type: 'mobile' } } });
        } else {
            if (venddProjectConfigs.Registration.GreekMobileValidation) {
                _.extend(valOpts.mobile, { isGreekMobile: 'mobile-invalid' });
            } else {
                _.extend(valOpts.mobile, { isPhoneNumber: 'mobile-invalid' });
            }
        }
    }

    //add password strength validation
    if ($('input[name="password"]', $form).length > 0) {
        valOpts.password = valOpts.password || {};
        _.extend(valOpts.password, { passwordStrength: { validator: 'password-weak', config: { limit: $form.data('pwdstrength') } } });
    }

    //add confirmation password match validation
    if ($('input[name="passwordConfirmation"]', $form).length > 0) {
        valOpts.passwordConfirmation = valOpts.passwordConfirmation || {};
        _.extend(valOpts.passwordConfirmation, { match: { validator: 'passwordConfirmation-match', matchField: 'password' } });
    }

    //add social security number validation
    if ($('input[name="socialSecurityNumber"]', $form).length > 0) {
        valOpts.socialSecurityNumber = { isSocialSecurityNumber: 'socialSecurityNumber-invalid' };
    }
    
    //add postalCode validation only if config parameter is true
    if (areaAutoCompleteEnabled && $('[name="area"]').length > 0) {
        valOpts.postalCode = valOpts.postalCode || {};

        if (formData.countryCode === "GR")
            _.extend(valOpts.postalCode, { isGreekPostalCode: { validator: 'postalCode-invalid', config: { areas: areas } } });

        if (formData.countryCode === "CY")
            _.extend(valOpts.postalCode, { isCypriotPostalCode: { validator: 'postalCode-invalid', config: { areas: areas } } });
    }

    $form.validationEngine(valOpts);
    var rf = $form.data('validationEngine');

    $.each($('.consent.checkbox[data-required]', $form), function (e, el) {
        var consentType = $('input', el);
        consentType.on('change', function () {
            rf.validate(consentType.attr('name'));
        });
    });

    $form.on('click', '.js-submit-button', function (e) {

        e.preventDefault();
        e.stopPropagation();

        var val1 = form.validateRecaptcha();
        var val2 = rf.validate();

        if (val1 && val2) {
            form.submit();
        } else {
            if ($('.form-row.with-error', $form).length > 0) {
                $('html,body').animate({ scrollTop: $('.form-row.with-error', $form).first().offset().top - 100 }, 600);
            }
        }
    });

    form.checkConsents = function () {
        var data = [];
        var checkboxes = $('.form-row.consent.checkbox', $form);
        $.each(checkboxes, function (e, el) {
            var chkbx = $('.checkbox-wrapper input', el);
            data.push({ type: chkbx.attr('id'), source: 'Registration Form', approved: chkbx.prop("checked") });
        });

        if (data.length > 0) {
            window.ConsentsManager.insertConsents(data);
        }
    };

    $form.on('click', '.js-password-reveal', function (e) {
        e.preventDefault();
        if ($(this).hasClass('shown')) {
            $(this).removeClass('shown').siblings('input').prop('type', 'password');
        } else {
            $(this).addClass('shown').siblings('input').prop('type', 'text');
        }
    });

    $form.on('change', 'select[name]', function (e) {
        //update validation for postal code
        if ($(this).attr('name') === "countryCode") {

            var countryCode = $(this).val();

            if (countryCode === formData.countryCode) return;

            form.resetAddressFields();
            form.updatePostalCode(countryCode);
        }

        form.setField($(this));
    });

    $form.on('keyup', 'input[name]:not([type="checkbox"]), textarea[name]', function (e) {
        //if (e.keyCode === 13) {
        //    e.preventDefault();
        //    e.stopPropagation();

        //    $submitButton.click();

        //    return;
        //}

        if ($(this).attr('name') === "password") {
            form.updatePasswordBar($(this));
            rf.validate("passwordConfirmation");
        }

        form.setField($(this));
    });

    $form.on('blur', 'input[name]:not([type="checkbox"]), textarea[name]', function (e) {
        if ($(this).attr('name') === "password") {
            form.updatePasswordBar($(this));
            rf.validate("passwordConfirmation");
        }

        form.setField($(this));
    });

    form.setField = function (field) {
        var fieldName = field.attr('name');
        formData[fieldName] = (fieldName === 'email' || fieldName === 'emailConfirmation') ? field.val().trim() : field.val();
        rf.validate(fieldName);
    };

    if (areaAutoCompleteEnabled && $('[name="area"]', $form).length > 0) {
        $form.on('keyup', 'input[name="postalCode"]', $.debounce(400, function () {
            var $this = $(this);
            var postalCode = $this.val();

            if (postalCode === null ||
                postalCode.length < 5 && formData.countryCode == "GR" ||
                (postalCode.length < 4 || !cyprusAreasEnabled) && formData.countryCode == "CY")
                return;

            Vendd.MessageBus.publishAsync(form, new Vendd.User.Messages.GetAreasForPostCode(formData.countryCode, postalCode, ""));
        }));

        $form.on('focus', 'input[name="area"]', function (e) {
            e.preventDefault();

            if (formData.countryCode === "GR" || (formData.countryCode === "CY" && cyprusAreasEnabled)) {
                $('input[name="postalCode"]', $form).focus();
            }
        });
    }

    if (invoiceAutoComplete) {
        $form.on('keyup', 'input[name = "taxIdentifier"]', $.debounce(400, function () {
            var $this = $(this);
            var taxIdentifier = $this.val();
            //ajax call for Vat Info Service
            vatInfoService(taxIdentifier);
        }));
    }

    if (venddProjectConfigs.phoneLocalizationEnabled) {
        if ($('input[name="phone"]', $form).length > 0) {
            $('input[name="phone"]', $form).get(0).addEventListener("countrychange", function () {
                formData.phone = $(this).val();
                rf = $form.data('validationEngine');
                rf.validate('phone');
            });
        }
        if ($('input[name="mobile"]', $form).length > 0) {
            $('input[name="mobile"]', $form).get(0).addEventListener("countrychange", function () {
                formData.mobile = $(this).val();
                rf = $form.data('validationEngine');
                rf.validate('mobile');
            });
        }
    }

    function vatInfoService(taxIdentifier) {

        if (taxIdentifier == null || taxIdentifier == '')
            return;

        Vendd.Service.call({
            url: 'EcomService.svc/GetVatInfo',
            data: {
                request: {
                    country: 'GR',
                    vat: taxIdentifier
                }
            },
            onSuccess: function (res) {
                if (res.isValid) {
                    if (res.name) {
                        $('input[name = "companyName"]:text').val(res.name);
                        formData.companyName = res.name;
                    }
                    if (res.occupation) {
                        $('input[name = "occupation"]:text').val(res.occupation);
                        formData.occupation = res.occupation;
                    }
                    if (res.taxAgency) {
                        $('select[name="taxAgency"]').val(res.taxAgency);
                        formData.taxAgency = res.taxAgency; 
                    }
                }
            },
            onFailure: function (res) {
                return;
            }
        });

    }

    $(".view-terms").fancybox({
        openEffect: 'none',
        closeEffect: 'none',
        maxWidth: 940,
        helpers: {
            overlay: {
                locked: true,
                closeClick: false
            }
        },
    });

    Vendd.MessageBus.subscribe(Vendd.User.Messages.B2BRegisterSuccess, form, form.onSuccess);

    Vendd.MessageBus.subscribe(Vendd.User.Messages.B2BRegisterFailure, form, form.onFailure);

    Vendd.MessageBus.subscribe(Vendd.Plugins.Messages.RecaptcaLoaded, form, form.initRecaptcha);

    Vendd.MessageBus.subscribe(Vendd.User.Messages.GetAreasForPostCodeSuccess, form, form.getAreasForPostCode);

});